<template>
    <div :class="preCls + 'content-box'">
        <div class="flex" style="margin-bottom: 4px">
            <!-- 选择排序 -->
            <Select
                style="width: 200px; margin-right: 15px"
                v-model="filter.orderBys"
                placeholder="排序类型"
                @on-change="search"
            >
                <Option
                    v-for="item in orderBysList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <!-- 高级搜索 -->
            <room-adv-search
                v-model="advFilter"
                ref="adv"
                @confirm="onAdvConfirm"
            ></room-adv-search>
        </div>
        <!-- 已选中的搜索条件 -->
        <select-tags
            v-model="advOptions"
            style="margin-bottom: 4px"
            @close="onAdvItemClose"
        ></select-tags>
        <!-- 表格工具栏 -->
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.keyword"
                    placeholder="请输入房源名称搜索"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <Button
                v-if="$can('update')"
                :class="preCls + 'button-margin'"
                :disabled="loading || !canBatchUpdate"
                type="primary"
                @click="onClickBatchUpdate"
            >
                批量修改
            </Button>
            <Button
                v-if="$can('update')"
                :class="preCls + 'button-margin'"
                :disabled="loading || !canPublish"
                @click="onClickBatchPublish"
            >
                批量上架
            </Button>
            <Button
                v-if="$can('update')"
                :class="preCls + 'button-margin'"
                :disabled="loading || !canUnPublish"
                @click="onClickBatchUnPublish"
            >
                批量下架
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
            @on-selection-change="onSelectChange"
        >
            <!-- 房间图片 -->
            <template #attachments="{ row }">
                <div style="font-size: 0">
                    <base-img
                        v-for="(src, index) in row.imgList"
                        :src="src"
                        :key="index"
                        style="margin: 2px"
                        width="44px"
                        height="44px"
                    >
                    </base-img>
                </div>
            </template>
            <!-- 操作列 -->
            <template #action="{ row }">
                <Button
                    v-if="$can('view')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="onRowClickInfo(row)"
                >
                    详情
                </Button>
                <Button
                    v-if="$can('update')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="onRowClickUpdate(row)"
                >
                    修改
                </Button>
                <Button
                    v-if="$can('update') && row.publishStatus != '1'"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="onRowClickPublish(row)"
                >
                    上架
                </Button>
                <Button
                    v-if="$can('update') && row.publishStatus == '1'"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="onRowClickUnPublish(row)"
                >
                    下架
                </Button>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            placement="top"
            @change="fetch"
        ></table-pager>
        <!-- 批量修改房间 -->
        <smart-modal
            v-model="modal.showRoomBatchEditForm"
            title="批量修改房间"
            :width="1080"
            :height="680"
            :maskClosable="false"
        >
            <room-batch-edit-form
                v-if="modal.showRoomBatchEditForm"
                :defaultHouseIds="curId"
                houseStatus="1"
                @search="search"
            />
        </smart-modal>
        <!-- 房间编辑 -->
        <smart-modal
            v-model="modal.showRoomForm"
            :title="actionTitle + '房间'"
            :width="800"
            :height="600"
            :maskClosable="false"
            @close-by-confirm="search"
        >
            <room-form
                v-if="modal.showRoomForm"
                :id="curId"
                :form-mode="formMode"
                enablePublishRules
            />
        </smart-modal>

      <!-- 批量上/下架 -->
      <smart-modal
        v-model="modal.showRoomPublish"
        :title="'批量' + (curUnPublish ? '下架' : '上架')"
        :width="960"
        :height="600"
        :maskClosable="false"
        @close-by-confirm="search"
      >
        <room-publish
          v-if="modal.showRoomPublish"
          :defaultHouseList="defaultHouseList"
          :unPublish="curUnPublish"
        />
      </smart-modal>

      <!--单个上架-->
      <smart-modal
        v-model="modal.showRoomSingPublish"
        title='发布管理'
        :width="960"
        :height="600"
        :maskClosable="false"
        @close-by-confirm="search"
      >
        <publish-manager
          v-if="modal.showRoomSingPublish"
          :id="curId"
        />
      </smart-modal>

    </div>
</template>

<script>
import mRentList from './m-rent-list'
import { mapCache } from '_g/vux-data-cache'
import { currency, getPublicImgUrls } from '_u/helper'
import { marketRoomList } from '@/api/assets'
import RoomBatchEditForm from '_v/assets/park/room-batch-edit-form'
import RoomForm from '_v/assets/park/room-form'
import RoomPublish from './room-publish'
import PublishManager from './publish-manager'

export default {
    name: 'room-rent-list',
    mixins: [mRentList],
    components: { RoomBatchEditForm, RoomForm, RoomPublish, PublishManager },
    data() {
        return {
            // state
            loading: false,
            mtHeight: 360,
            selection: [],
            defaultHouseList: [],
            curId: '',
            curUnPublish: false,
            // data
            page: {
                total: 0,
                list: [],
            },
            dict: {
                parkType: this.$dict.NULL,
                decorationType: this.$dict.NULL,
                rentTypeNew: this.$dict.NULL,
                orientation: this.$dict.NULL,
                houseTag: this.$dict.NULL,
                publishStatus: this.$dict.NULL,
            },
            modal: {
                showRoomBatchEditForm: false,
                showRoomForm: false,
                showRoomPublish: false,
                showRoomSingPublish: false,
            },
        }
    },
    computed: {
        ...mapCache({
            filter: 'rentFilter',
            advFilter: 'rentAdvFilter',
            advOptions: 'rentAdvOptions',
        }),
        columns() {
            return [
                { type: 'selection', width: 60, align: 'center' },
                {
                    type: 'index',
                    minWidth: 80,
                    title: '序号',
                    align: 'center',
                },
                {
                    key: 'houseName',
                    minWidth: 140,
                    title: '房源名称',
                },
                {
                    key: 'buildArea',
                    minWidth: 100,
                    title: '面积(m2)',
                    align: 'right',
                },
                {
                    key: 'rentTypeText',
                    minWidth: 100,
                    title: '出租类型',
                },
                {
                    key: 'orientationText',
                    minWidth: 80,
                    title: '朝向',
                },
                {
                    key: 'houseType',
                    minWidth: 120,
                    title: '户型',
                },
                {
                    key: 'rentText',
                    minWidth: 140,
                    title: '月租金',
                },
                {
                    key: 'commissionText',
                    minWidth: 140,
                    title: '佣金',
                },
                {
                    key: 'publishStatusText',
                    minWidth: 100,
                    title: '发布状态',
                },
                {
                    key: 'factitleText',
                    minWidth: 140,
                    title: '房屋配置',
                },
                {
                    key: 'attachments',
                    minWidth: 220,
                    title: '房间图片',
                    slot: 'attachments',
                },
                {
                    minWidth: 180,
                    title: '操作',
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },
        canBatchUpdate() {
            return (
                // 不能包含已上架房间
                this.selection.every((v) => v.publishStatus != '1')
            )
        },
        canPublish() {
            return (
                this.selection.length > 0 &&
                // 不能包含已上架房间
                this.selection.every((v) => v.publishStatus != '1')
            )
        },
        canUnPublish() {
            return (
                this.selection.length > 0 &&
                // 只能是已上架房间
                this.selection.every((v) => v.publishStatus == '1')
            )
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                60
        })
    },
    methods: {
        // 查询
        fetch() {
            this.loading = true

            return Promise.all([
                this.$dict.get([
                    'park_type',
                    'decoration_type',
                    'rent_type_new',
                    'orientation',
                    'house_tag',
                    'publish_status',
                ]),
                marketRoomList(
                    Object.assign(
                        {},
                        this.filter,
                        this.normalizeAdvFilter(this.advFilter)
                    )
                ),
            ])
                .then((args) => {
                    var [group, rooms] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = group[name]
                    })

                    this.setPageData(rooms.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        // 搜索
        search() {
            this.filter.pageNo = 1
            this.fetch()
        },
        // 设置分页数据
        setPageData(data) {
            var list = data.page.list

            list.forEach((v) => {
                var factitleList = v.factitle ? v.factitle.split([',']) : []

                v.rentText = currency(v.rent)
                v.commissionText = currency(v.commission)
                v.rentTypeText = this.dict.rentTypeNew.val(v.rentType)
                v.orientationText = this.dict.orientation.val(v.orientation)
                v.factitleText =
                    factitleList.length > 2
                        ? factitleList.slice(0, 2).join(',') +
                          '等' +
                          factitleList.length +
                          '个'
                        : factitleList.slice(0, 2).join(',')
                v.publishStatusText =
                    this.dict.publishStatus.val(v.publishStatus) || '待上架'
                v.imgList = getPublicImgUrls(v.attachments)
            })

            this.page.list = list
            this.page.total = parseInt(data.page.totalCount)
        },
        // 行勾选
        onSelectChange(selection) {
            this.selection = selection
        },
        // 批量修改
        onClickBatchUpdate() {
            this.curId = this.selection.map((v) => v.id).join(',')
            this.modal.showRoomBatchEditForm = true
        },
        // 批量下架
        onClickBatchUnPublish() {
            this.defaultHouseList = this.selection
            this.curUnPublish = true
            this.modal.showRoomPublish = true
        },
        // 批量上架
        onClickBatchPublish() {
            this.defaultHouseList = this.selection
            this.curUnPublish = false
            this.modal.showRoomPublish = true
        },
        // 查看详情
        onRowClickInfo(row) {
            this.curId = row.id
            this.formMode = this.FORM_MODE.view
            this.modal.showRoomForm = true
        },
        // 房源编辑
        onRowClickUpdate(row) {
            this.curId = row.id
            this.formMode = this.FORM_MODE.update
            this.modal.showRoomForm = true
        },
        // 行上架
        onRowClickPublish(row) {
            this.curId = row.id
            this.defaultHouseList = [row]
            this.curUnPublish = false
            // this.modal.showRoomSingPublish = true
            this.modal.showRoomPublish = true
        },
        // 行下架
        onRowClickUnPublish(row) {
            this.curId = row.id
            this.defaultHouseList = [row]
            this.curUnPublish = true
            // this.modal.showRoomSingPublish = true
            this.modal.showRoomPublish = true
        },
    },
}
</script>

<style lang="less"></style>
